import { createGlobalStyle } from 'styled-components'

import { type Theme, rebrandTheme, theme } from './theme'

/**
 * @todo switch to rebrand theme as soon as it is rolled out
 */
export const GlobalStyle = createGlobalStyle<{ contaTheme?: Theme }>`
  * {
    font-family: var(--font-sharon-sans), "Sharon Sans", Helvetica, Arial, sans-serif;
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    -moz-osx-font-smoothing: grayscale;
    text-rendering: optimizeLegibility;
    text-size-adjust: none;
    -webkit-font-smoothing: antialiased;
  }

  :root{
    line-height: 1.5;
    color: ${theme.colors.darkGray};
  }

  body {
    background:  ${({ contaTheme }) => (contaTheme === rebrandTheme ? theme : rebrandTheme).colors.lightGray};
  }

  .debug > * {
    border: 2px solid ${theme.colors.danger};
  }

  @media print {
    .hide-when-print {
      display: none;
    }
  }

  .grecaptcha-badge {
    visibility: hidden;
  }
`
